<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.editBankAccName.title') }}</p>
      </header>
      <section class="modal-card-body">
        <div class="field">
          <label for="" class="label"
            >*** {{ $t('modals.editBankAccName.warningTxt') }} ***</label
          >
          <input
            v-model="bankAccountName"
            type="text"
            :placeholder="$t('modals.editBankAccName.accNamePla')"
            class="input text-center"
            v-uppercase
          />
        </div>
        <div class="box-button m-t-30">
          <button
            type="submit"
            class="button full-100 is-danger"
            @click="handleSubmit"
          >
            {{ $t('modals.editBankAccName.editBtn') }}
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiAccount from '@/api/account'
import i18n from '@/language'
export default {
  name: 'ModalEditProfile',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object
    }
  },
  data() {
    return {
      bankAccountName: ''
    }
  },
  created() {
    this.bankAccountName = this.account.bankAccountName
  },
  methods: {
    async handleSubmit() {
      const re = /^[A-Z\s]+$/i

      if (!this.bankAccountName || !re.test(this.bankAccountName)) {
        this.$buefy.toast.open({
          message: i18n.t('modals.editBankAccName.requiredEngLangMsg'),
          type: 'is-danger'
        })
        return
      }

      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiAccount.updateBankAccountName(
            this.account.bankCode,
            this.bankAccountName
          )
          if (data) {
            this.$emit('closeModal', this.bankAccountName)
          }
          loading.hide()
        } catch (error) {
          this.$buefy.toast.open({
            message: error.message ? error.message : error,
            type: 'is-danger'
          })
          loading.hide()
        }
      }, 200)
    }
  }
}
</script>

<style scoped lang="scss"></style>
